<template>
    <div class="d-flex align-center justify-space-between px-6 pt-4">
        <div class="text-h6 medium">
            {{ translate('common.how_may_we_be_in_touch') }}
        </div>
        <div
            v-if="!is_mobile_number_only_flow"
            class="text-caption text-no-wrap"
        >
            1 / 2
        </div>
    </div>
    <div class="text-subtitle-2 px-6 pt-2">
        {{
            translate(
                is_mobile_number_only_flow
                    ? 'common.you_need_to_enter_your_phone_number'
                    : 'common.how_may_we_be_in_touch_text'
            )
        }}
    </div>
    <div class="px-6 pt-6">
        <PhoneField
            v-model:input="internal_mobile_number"
            v-model:valid="internal_is_mobile_number_valid"
            :preferred_countries="['SE', 'DK', 'NO', 'FI', 'IS']"
            :required="is_mobile_number_only_flow"
            class="mb-4"
            invalid_message="common.invalid_mobile_number"
            label="common.mobile_number"
        />
        <TextField
            v-if="!is_mobile_number_only_flow"
            v-model:input="internal_email"
            v-model:valid="internal_is_email_valid"
            :label="translate('common.email')"
            :rules="[(v) => validate_email(v)]"
            placeholder="example@example.com"
            type="email"
        />
    </div>
</template>

<script>
import { locales_mixin } from '@old/mixins/locales_mixin'
import { rules_mixin } from '@old/mixins/rules_mixin'
import TextField from '@old/components/input/TextField.vue'
import PhoneField from '@old/components/input/PhoneField.vue'

export default {
    name: 'ProfileDialogContactInfo',
    props: {
        mobile_number: {
            type: String,
        },
        is_mobile_number_valid: {
            type: Boolean,
        },
        email: {
            type: String,
        },
        is_email_valid: {
            type: Boolean,
        },
        is_mobile_number_only_flow: {
            type: Boolean,
        },
    },
    mixins: [locales_mixin, rules_mixin],
    components: { PhoneField, TextField },
    emits: ['update:mobile_number', 'update:is_mobile_number_valid', 'update:email', 'update:is_email_valid'],
    data() {
        return {}
    },
    computed: {
        internal_mobile_number: {
            get() {
                return this.mobile_number
            },
            set(value) {
                this.$emit('update:mobile_number', value)
            },
        },
        internal_is_mobile_number_valid: {
            get() {
                return this.is_mobile_number_valid
            },
            set(value) {
                this.$emit('update:is_mobile_number_valid', value)
            },
        },
        internal_email: {
            get() {
                return this.email
            },
            set(value) {
                this.$emit('update:email', value)
            },
        },
        internal_is_email_valid: {
            get() {
                return this.is_email_valid
            },
            set(value) {
                this.$emit('update:is_email_valid', value)
            },
        },
    },
    watch: {},
    methods: {},
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeUnmount() {},
}
</script>

<style scoped lang="sass"></style>
